<template>
  <PageTemplate>
    <h1>Edit Personal Details</h1>
    <v-card :title="currentUser.first_name + ' ' + currentUser.last_name + ' \'s Personal Details'">
      <template>
        <div
          v-if="!isTAAdmin() || !isTAUserAndHasUserInfo()"
          class="row"
        >
          <div class="col-md-12">
            <v-label text="Select User Type*" />
            <fieldset class="fieldset">
              <v-checkbox
                v-for="role in defaultRoles"
                :id="role.id"
                :key="role.id"
                :value="role.value"
                :checked="containsObject(role,form.roles)"
                @check="checkInObj(role,form.roles)"
              >
                {{ role.value }}
              </v-checkbox>
              <v-input-help
                v-if="roleCheckError"
                class="fieldset__text"
                :text="roleCheckError"
              />
            </fieldset>
          </div>
          <v-fieldset
            id="first_name"
            v-model="form.first_name"
            class="col-md-6"
            text="First Name*"
            placeholder="First Name"
            :is-required="true"
            :help-text="validationErrors.first_name"
          />
          <v-fieldset
            id="last_name"
            v-model="form.last_name"
            class="col-md-6"
            text="Last Name*"
            placeholder="Last Name"
            :is-required="true"
            :help-text="validationErrors.last_name"
          />
          <v-fieldset
            id="title"
            v-model="form.title"
            class="col-md-6"
            text="Position Title*"
            placeholder="Title"
            :is-required="true"
            :help-text="validationErrors.title"
          />
          <v-fieldset
            id="mobile_number"
            v-model="form.mobile_number"
            class="col-md-6"
            text="Phone*"
            pattern="[+]?\d*"
            placeholder="Phone Number"
            :is-required="true"
            :help-text="validationErrors.mobile_number"
          />
          <v-fieldset
            id="email"
            v-model="form.email"
            class="col-md-6"
            text="Email*"
            type="email"
            placeholder="Email"
            :is-required="true"
            :help-text="validationErrors.email"
          />
          <v-fieldset
            id="address"
            v-model="form.address"
            class="col-md-6"
            text="Address*"
            placeholder="Address"
            :is-required="true"
            :help-text="validationErrors.address"
          />
          <v-fieldset
            id="country"
            v-model="form.country"
            class="col-md-6"
            text="Country"
            placeholder="Country"
            :help-text="validationErrors.country"
          />
          <v-fieldset
            v-if="states.length > 0"
            id="state"
            v-model="form.state"
            class="col-md-6"
            text="State"
            placeholder=" "
            :select-options="states"
            :help-text="validationErrors.state"
          />
          <v-fieldset
            id="suburb"
            v-model="form.suburb"
            class="col-md-6"
            text="Suburb"
            placeholder="Suburb"
            :help-text="validationErrors.suburb"
          />
          <v-fieldset
            id="postcode"
            v-model="form.postcode"
            class="col-md-6"
            pattern="^[0-9]+$"
            text="Post Code"
            placeholder="Post Code"
            :help-text="validationErrors.postcode"
          />
          <v-fieldset
            v-if="valueExistInObjArray(constants.NATA_ROLE_TA,form.roles)"
            id="userId"
            v-model="form.userId"
            class="col-md-6"
            placeholder="User ID"
            text="User ID"
            :is-required="true"
            :help-text="validationErrors.userId"
          />
        </div>
        <div
          v-else
          class="row"
        >
          <!-- TA Profile
          {{ currentUser }}
          {{ fieldErrors }} -->
          <br>
          <div class="col-md-6 d-flex">
            <v-card title="Personal Details">
              <v-fieldset
                id="title"
                v-model="form.title"
                name="title"
                text="Position Title*"
                type="text"
                is-required
                :help-text="fieldErrors.title"
                @input="(e) => form.title.trim() == '' ? fieldErrors.title=requiredError:delete fieldErrors.title"
              />
              <v-fieldset
                id="first_name"
                v-model="form.first_name"
                name="first_name"
                text="First Name*"
                type="text"
                is-required
                :help-text="fieldErrors.first_name"
                @input="(e) => form.first_name.trim() == '' ? fieldErrors.first_name=requiredError:delete fieldErrors.first_name"
              />
              <v-fieldset
                id="last_name"
                v-model="form.last_name"
                name="last_name"
                text="Last Name*"
                type="text"
                is-required
                :help-text="fieldErrors.last_name"
                @input="(e) => form.last_name.trim() == '' ? fieldErrors.last_name=requiredError:delete fieldErrors.last_name"
              />
            </v-card>
          </div>
          <div class="col-md-6 d-flex">
            <v-card title="User Roles">
              <fieldset class="fieldset">
                <v-checkbox
                  v-for="role in defaultRoles"
                  :id="role.id"
                  :key="role.id"
                  :value="role.value"
                  :checked="containsObject(role,form.roles)"
                  @check="checkInObj(role,form.roles)"
                >
                  {{ role.value }}
                </v-checkbox>
                <v-input-help
                  v-if="roleCheckError"
                  class="fieldset__text"
                  :text="roleCheckError"
                />
              </fieldset>
            </v-card>
          </div>
          <div class="col-md-6 d-flex">
            <v-card title="Email Details">
              <div class="col-md-12 d-flex gap-in-list">
                <div class="col-md-2">
                  Type
                </div>
                <div class="col-md-8">
                  Email
                </div>
                <div class="col-md-2 primaryTitle">
                  Primary
                </div>
              </div>
              <div
                v-for="(item, index) in currentUser.user_info.csv_info.emails"
                :key="item.Type"
                class="col-md-12 d-flex gap-in-list"
              >
                <div class="col-md-2">
                  <strong>{{ item.Type }}:</strong>
                </div>
                <div class="col-md-8">
                  <!-- {{ item }} -->
                  <v-fieldset
                    :id="`email_${index}`"
                    v-model="item.email"
                    :name="`${item.Type}_email`"
                    type="email"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                    is-required
                    :help-text="fieldErrors[`${item.Type}_email`]"
                    @input="(e) => item.email.trim() == '' ? fieldErrors[`${item.Type}_email`]=requiredError:delete fieldErrors[`${item.Type}_email`]"
                  />
                </div>
                <div class="col-md-2 primaryTitle">
                  <input
                    id="email_isPrimary"
                    name="email_isPrimary"
                    class="following__control"
                    type="radio"
                    :checked="item.isPrimary"
                    @change="(e) => primaryOptionChange('emails', e, item.Type, index)"
                  >
                </div>
              </div>
            </v-card>
          </div>
          <div class="col-md-6 d-flex">
            <v-card title="Phone Details">
              <div class="col-md-12 d-flex gap-in-list">
                <div class="col-md-2">
                  Type
                </div>
                <div class="col-md-8">
                  Phone
                </div>
                <div class="col-md-2 primaryTitle">
                  Primary
                </div>
              </div>
              <div
                v-for="(item, index) in currentUser.user_info.csv_info.phones"
                :key="`Phone_${item.Type}_${index}`"
                class="col-md-12 d-flex gap-in-list"
              >
                <div class="col-md-2">
                  <strong>{{ item.Type }}:</strong>
                </div>
                <div class="col-md-8">
                  <!-- {{ item }} -->
                  <div class="row">
                    <div class="col-md-3">
                      <v-fieldset
                        :id="`${item.Type}_countryCode`"
                        v-model="item.countryCode"
                        :name="`${item.Type}_countryCode`"
                        type="text"
                        pattern="[+]\d*"
                        is-required
                        :help-text="fieldErrors[`${item.Type}_countryCode`]"
                        @input="(e) => item.countryCode.trim() == '' ? fieldErrors[`${item.Type}_countryCode`]=requiredError:delete fieldErrors[`${item.Type}_countryCode`]"
                      />
                    </div>
                    <div class="col-md-9">
                      <v-fieldset
                        :id="`${item.Type}_phoneNumber`"
                        v-model="item.phoneNumber"
                        :name="`${item.Type}_phoneNumber`"
                        type="text"
                        pattern="\d*"
                        is-required
                        :help-text="fieldErrors[`${item.Type}_phoneNumber`]"
                        @input="(e) => item.phoneNumber.trim() == '' ? fieldErrors[`${item.Type}_phoneNumber`]=requiredError:delete fieldErrors[`${item.Type}_phoneNumber`]"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-2 primaryTitle">
                  <input
                    id="phone_isPrimary"
                    name="phone_isPrimary"
                    class="following__control"
                    type="radio"
                    :checked="item.isPrimary"
                    @change="(e) => primaryOptionChange('phones', e, item.Type, index)"
                  >
                </div>
              </div>
            </v-card>
          </div>
          <div
            v-for="(item, index) in currentUser.user_info.csv_info.addresses"
            :key="index"
            class="col-md-6 d-flex"
          >
            <v-card
              :title="getAddressTitle(item)"
            >
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="address-primary"
                  >
                    Primary&nbsp;&nbsp;&nbsp;
                    <input
                      id="address_isPrimary"
                      name="address_isPrimary"
                      class="following__control"
                      type="radio"
                      :checked="item.isPrimary"
                      @change="(e) => primaryOptionChange('addresses', e, item.Type, index)"
                    >
                  </div>
                </div>
                <div class="col-md-12">
                  <!-- Address details here! {{ item }}
                  <br> -->
                  <v-fieldset
                    :id="`${item.Type}_AddressLine`"
                    v-model="item.AddressLine"
                    :name="`${item.Type}_AddressLine`"
                    text="Address*"
                    type="text"
                    is-required
                    :help-text="fieldErrors[`${item.Type}_AddressLine`]"
                    @input="(e) => item.AddressLine.trim() == '' ? fieldErrors[`${item.Type}_AddressLine`]=requiredError:delete fieldErrors[`${item.Type}_AddressLine`]"
                  />
                  <div class="row">
                    <div class="col-md-6">
                      <v-fieldset
                        :id="`${item.Type}_Country`"
                        v-model="item.Country"
                        :name="`${item.Type}_Country`"
                        text="Country*"
                        type="text"
                        is-required
                        :help-text="fieldErrors[`${item.Type}_Country`]"
                        @input="(e)=> { countryChange(e, item);
                                        item.Country.trim() == '' ? fieldErrors[`${item.Type}_Country`]=requiredError:delete fieldErrors[`${item.Type}_Country`]}"
                      />
                    </div>
                    <div class="col-md-6">
                      <v-fieldset
                        v-if="states.length > 0"
                        :id="`${item.Type}_State`"
                        v-model="item.State"
                        :name="`${item.Type}_State`"
                        class="col-lg-12"
                        text="State"
                        :select-options="states"
                        :disabled="addressTypeStatesDisabled[`${item.Type}_State`]"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <v-fieldset
                        :id="`${item.Type}_Suburb`"
                        v-model="item.Suburb"
                        :name="`${item.Type}_Suburb`"
                        text="Suburb*"
                        type="text"
                        is-required
                        :help-text="fieldErrors[`${item.Type}_Suburb`]"
                        @input="(e) => item.Suburb.trim() == '' ? fieldErrors[`${item.Type}_Suburb`]=requiredError:delete fieldErrors[`${item.Type}_Suburb`]"
                      />
                    </div>
                    <div class="col-md-6">
                      <v-fieldset
                        :id="`${item.Type}_Postcode`"
                        v-model="item.Postcode"
                        :name="`${item.Type}_Postcode`"
                        text="Post Code*"
                        type="text"
                        pattern="\d*"
                        is-required
                        :help-text="fieldErrors[`${item.Type}_Postcode`]"
                        @input="(e) => {
                          item.Postcode.trim() == '' ? fieldErrors[`${item.Type}_Postcode`]=requiredError:delete fieldErrors[`${item.Type}_Postcode`];
                          item.Postcode.trim()*1 != item.Postcode.trim() ? fieldErrors[`${item.Type}_Postcode`]='Invalid post code.':delete fieldErrors[`${item.Type}_Postcode`]
                        }"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
        </div>
      </template>
      <template v-if="valueExistInObjArray(constants.NATA_ROLE_AR,form.roles)">
        <div
          v-for="(item,index) in form.facilities"
          :key="index"
        >
          <v-headline
            :text="'Facility '+ setFacilitySeq(index)"
            :level="4"
          >
            <v-button
              color="transparent"
              @click="delFacility(index,item)"
            >
              <v-icon type="times" />
            </v-button>
          </v-headline>
          <div class="row">
            <v-fieldset
              :id="'facility_number ' + index"
              v-model="item.facility_number"
              class="col-md-6"
              text="Facility Accreditation Number*"
              placeholder="Please input facility number"
              :is-required="true"
              :readonly="checkEditable(index,'facility_name')"
              @keyup="getFacility($event, index)"
            />
            <v-fieldset
              :id="'facility ' + index"
              v-model="item.facility_name"
              class="col-md-6"
              text="Facility Name*"
              placeholder="Facility name"
              :is-required="true"
              :readonly="true"
            />
            <div
              v-if="item.allSites && item.allSites.length>0"
              class="col-md-6"
            >
              <v-checkbox
                v-for="site in item.allSites"
                :id="site.site_number"
                :key="site.site_number"
                :value="site.site_number"
                :checked="containsObject(site,item.sites,true)"
                @check="checkInObj(site,item.sites,true)"
              >
                {{ site.site_number }} - {{ site.name }}
              </v-checkbox>
            </div>
          </div>
        </div>
        <v-button
          color="secondary"
          style="margin-top:12px; margin-bottom:12px;"
          @click="addFacility()"
        >
          <v-icon type="plus" />
          Add Facility
        </v-button>
      </template>
      <template v-if="valueExistInObjArray(constants.NATA_ROLE_CM,form.roles)">
        <div>
          <strong>Select at least One or More Committees if Applicable from the List of Committees</strong>
          <fieldset class="fieldset">
            <v-checkbox
              v-for="committee in committees"
              :id="committee.id"
              :key="committee.value"
              :value="committee.value"
              :checked="containsObject(committee,form.committees,true)"
              @check="checkInObj(committee,form.committees)"
            >
              {{ committee.value }}
            </v-checkbox>
          </fieldset>
        </div>
      </template>
      <template>
        <h4>Subscriptions</h4>
        <div v-if="generalPublicationCat.length > 0">
          <v-label text="General Publication" />
          <v-checkbox-list
            id="general"
            v-model="selectedGeneralPublication"
            :groups="generalPublicationCat"
            :selected-group="selectedGeneralPublication"
            @change="userSubscriptionChange"
          />
        </div>
      </template>
      <template>
        <v-button-group
          is-left
          class="row"
        >
          <v-button
            size="lg"
            has-min-width
            :disabled="Object.keys(fieldErrors).length > 0 || disableSave"
            @click="save"
          >
            Save
          </v-button>
          <v-button
            size="lg"
            color="danger"
            has-min-width
            @click="cancel"
          >
            Cancel
          </v-button>
        </v-button-group>
      </template>
    </v-card>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page";
  import Card from "@/molecules/Card";
  import Icon from "@/atoms/Icon";
  import Button from "@/atoms/Button";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Headline from "@/atoms/Headline";
  import InputHelp from "@/atoms/InputHelp";
  import Fieldset from "@/molecules/Fieldset";
  import Checkbox from "@/atoms/Checkbox";
  import CheckboxList from "@/molecules/CheckboxList";
  import Label from "@/atoms/Label";
  import {buildBreadCrumb,buildDefinitionList, zeroPad} from "@/common/tableFunctions"
  import {mapState} from "vuex";
  import {
    GET_ALL_USERS,
    GET_USER_INFO,
    GET_FACILITY_INFO, GET_COMMITTEES, UPDATE_USER_DETAIL, GET_ALL_PUBLICATION_CATEGORIES
  } from "../../store/actions.type";
  import constants from "../../common/constants";
  import routes from "@/common/routes";

  export default {
    name: "EditPersonalDetails",
    components: {
      "v-card": Card,
      "v-icon": Icon,
      "v-button": Button,
      "v-button-group": ButtonGroup,
      "v-checkbox": Checkbox,
      "v-fieldset": Fieldset,
      "v-headline": Headline,
      "v-input-help": InputHelp,
      "v-label": Label,
      "v-checkbox-list": CheckboxList,
      PageTemplate
    },
    data: () => ({
      updatedSubscription: null,
      defaultRoles: [
        {
          "id": constants.NATA_ROLE_AR,
          "value": "Authorised Representative",
        },
        {
          "id": constants.NATA_ROLE_CM,
          "value": "Committee Member",
        },
        {
          "id": constants.NATA_ROLE_TA,
          "value": "Technical Assessor",
        },
        {
          "id": constants.NATA_ROLE_TA_ADMIN,
          "value": "Technical Assessor Admin",
        }
      ],
      roleCheckError: '',
      states:[],
      original:{},
      form:{
        email:'',
        first_name:'',
        last_name:'',
        roles:[],
        address:'',
        billing_address: '',
        suburb: '',
        state: '',
        country: '',
        postcode:'',
        mobile_number:'',
        title:'',
        userId:'',
        facilities:[],
        committees:[],
        subscriptions:[],
      },
      publication_categories:[],
      user_facilities:[],
      committees: [],
      validationErrors:{},
      facilityError:'',
      personalDetailIsReady: false,
      facilityDetailIsReady: false,
      committeeIsReady: false,
      isConfirm: false,
      fieldErrors: {},
      addressTypeStatesDisabled: [],
      requiredError: 'This field is required.',
      disableSave: false
    }),
    computed: {
      ...mapState({
        users: state => state.userRequest.users,
        currentUser: state => state.userRequest.currentUser,
        accessDetails : state => state.userRequest.accessDetails,
        selectedSites : state => state.userRequest.selectedSites,
        userCommittees : state => state.userRequest.committees,
        subscriptions: state => state.userRequest.subscriptions,
        roles: state => state.userRequest.currentRoles,
      }),
      selectedGeneralPublication:{
        get(){
          let results = [];
          for (let sub of this.subscriptions) {
            sub.selected = 1;
            results.push(sub);
          }
          results = this.formatSubscriptionListForCheckBox(results);
          return results;
        },
        set(val){
          this.form.subscriptions[0].selected = val;
        }
      },

      generalPublicationCat(){
        let general = this.publication_categories;
        let data = this.formatCheckboxList(general);
        return data
      }
    },
    watch:{
      subscriptions:{
        handler:function(val){
          this.form.subscriptions = val;
        }
      },
      roles:{
        handler:function(val){
          let arr = [];
          for(let i in val)
          {
            let role = {};
            role.id = val[i];
            role.value = constants.USER_ROLES.find(r => r.name === role.id).fullName;
            arr.push(role)
          }
          this.form.roles = arr;
          this.original.roles = arr;
        }
      },
      userCommittees:{
        handler:function(val){
          /**
           * Wait get all committees return
           */
          if(this.committees.length > 0 && this.valueExistInObjArray(constants.NATA_ROLE_CM,this.form.roles)){
            let arr = [];
            let userComs = val[0].desc.split(',');
            for(let i in userComs)
            {
              let com = {};
              com.id = this.committees.filter(el => el.value == userComs[i])[0].id;
              com.value = userComs[i]
              arr.push(com)
            }
            this.form.committees = arr;
            this.original.committees = arr;
          }
        }
      },
      committees:{
        handler:function(val) {
          if(this.committees.length > 0){
            let arr = [];
            if(this.userCommittees.length > 0){
              let userComs = this.userCommittees[0].desc.split(',');
              for(let i in userComs)
              {
                let com = {};
                let temp = this.committees.filter(el => el.value == userComs[i]);
                if(temp.length > 0)
                  com.id = temp[0].id;
                com.value = userComs[i]
                arr.push(com)
              }
            }
            this.form.committees = arr;
            this.original.committees = arr;
          }
        }
      },
      form:{
        deep:true,
        handler:function(val,oldVal)
        {
          for(let key in val){
            const checkField = document.getElementById(key);
            if(checkField != null && checkField.value.length > 0){
              const isValid = checkField.checkValidity();
              if(!isValid){
                this.validationErrors[key] = 'Please input valid detail for  '+ checkField.placeholder;
              }else{
                delete this.validationErrors[key];
              }
            }
          }
          try{
            this.personalDetailIsReady = (Object.keys(this.validationErrors).length === 0 && this.form.roles.length > 0);
          }catch(e) {
            console.log('Error: '+e);
          }
        }
      },
      selectedSites: {
        handler: async function(val){
          await this.setAllSitesForSelectedFacilities(val);
          this.form.facilities = JSON.parse(JSON.stringify(val));
        }
      }
    },
    created() {
      this.constants = constants;
    },
    mounted() {
      this.resetStates();
      this.updateBreadCrumb();
      this.getCommittee();
      this.getPublicationCat();
      this.getUsers();
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['All Users'] = routes.ADMIN.USERS;
        breadcrumbs['User Profile'] = routes.ADMIN.USER + this.$route.params.id;
        breadcrumbs['Edit Personal Details'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      userSubscriptionChange(evt) {
        this.updatedSubscription = evt;
      },
      updateForm:function() {
        /**
         * copy basic personal detail to form data
         * @type {any}
         */
        let currentDetails = JSON.parse(JSON.stringify(this.currentUser));

        for(let key in currentDetails)
        {
          if(this.form.hasOwnProperty(key) && key != 'roles')
          {
            this.form[key] = currentDetails[key];
          }
        }

        this.original = JSON.parse(JSON.stringify(this.form));
        this.user_facilities = JSON.parse(JSON.stringify(this.accessDetails)).map(el => el[0].desc)
        this.form.userId = currentDetails.resource_id;
        this.original.userId = currentDetails.resource_id;
      },
      getPublicationCat(){
        this.$store.dispatch(GET_ALL_PUBLICATION_CATEGORIES)
          .then(response => {
            if (response.success) {
              this.publication_categories = response.data;
            }
          });
      },
      getCommittee() {
        this.$store.dispatch(GET_COMMITTEES)
          .then(response => {
            if (response.success) {
              this.committees = response.data;
            }
          });
      },
      resetStates(){
        this.states = constants.USER_STATES;
      },
      valueExistInObjArray(value, array) {
        return array && array.some(elem => elem.id === value)
      },
      getUsers(){
        if(this.$store.state.userRequest.users && this.$store.state.userRequest.users.length > 0) {
          this.getUser(this.$route.params.id);
          this.getUserInfo(this.$route.params.id);
          this.updateForm();
          return;
        }
        this.$store.dispatch(GET_ALL_USERS).then(response => {
          this.getUser(this.$route.params.id);
          this.getUserInfo(this.$route.params.id);
          this.updateForm()
        });
      },
      getUser(id)
      {
        this.$store.dispatch('updateCurrentUser',id).then(resposne => {
          this.isActive = this.currentUser.activated !== 0;
        });
      },
      getUserInfo(id)
      {
        this.$store.dispatch(GET_USER_INFO,id);
      },
      containsObject(obj, list,isSite) {
        if(isSite){
          for(let i = 0;i<list.length;i++){
            if(obj.id === list[i].id){
              return true
            }
          }
        }else{
          try {
            for (let i = 0; i < list.length; i++) {
              if (JSON.stringify(list[i]) == JSON.stringify(obj)) {
                return true;
              }
            }
          }catch(e) {
            console.log('Error: '+e);
          }
        }
        return false;
      },
      checkInObj(obj, objArr,isSite,parent_id) {
        if (objArr.some(o => o.id === obj.id)) {
          objArr.splice(objArr.findIndex(o => o.id === obj.id), 1)
        } else {
          if(isSite === true){
            let temp = {};
            temp.id = obj.id;
            temp.value = obj.site_number+'-'+obj.name;
            objArr.push(temp)
          }else if(isSite === false && (obj.id === parent_id))
          {
            let temp = {};
            temp.id = obj.id;
            temp.value = obj.value;
            temp.children = [];
            objArr.push(temp)
          }
          else{
            let temp = {};
            temp.id = obj.id;
            temp.value = obj.value ? obj.value:obj.name;
            objArr.push(temp)
          }
        }
      },
      setFacilitySeq(index) {
        return parseInt(index) + 1;
      },
      delFacility(index,item) {
        //  del facility when user click 'x'
          this.facilityError = '';
          this.form.facilities.splice(index,1);
          this.user_facilities.splice(this.user_facilities.indexOf(item.facility_number),1);
      },
      checkDuplicateFacility(facility_number) {
        //  check if duplicate value exists.
        return this.user_facilities.indexOf(facility_number) !== -1;
      },
      formatFacility(params) {
        let result = [];
        for (let key in params) {
          if(key === 'facility_number'){
            let title = 'Facility Accreditation Number';
            let obj = {
              'title': title,
              'desc': params[key]
            };
            result.push(obj);
          }else if(key === 'facility_name'){
            let title = 'Facility Name';
            let obj = {
              'title': title,
              'desc': params[key]
            };
            result.push(obj);
          }else if(key === 'sites'){
            var sites = '';
            for(let k in params[key])
            {
              sites += (params[key][k]['value']) + ','
            }
            let title = 'Site Number and Site Name';
            let obj = {
              'title': title,
              'desc': sites
            };
            result.push(obj);
          }
        }
        return result;
      },
      checkEditable(index,property){
        return (this.form.facilities[index][property].length > 0);
      },
      getFacility(value, index) {
        value = zeroPad(''+value, 6);
        this.form.facilities[index].facility_number = value;
        //  Get facility name if facility number is existed in DB;
        this.$store.dispatch(GET_FACILITY_INFO, value)
          .then(response => {
            if (response === undefined) {
              this.$notify({
                title: 'Error',
                text: 'Facility number is invalid.',
                type: 'error'
              });
              this.delFacility(index);
            }
            else if (this.checkDuplicateFacility(response.facility_number, index) === true) {
              this.$notify({
                title: 'Error',
                text: 'Duplicate facilities are not allowed.',
                type: 'error'
              });
              this.delFacility(index);
            }
            else {
              this.setFacility(response, index);
            }
          });
      },
      setFacility(data, index) {
        //  set facility name and make the input not editable
        this.user_facilities.push(data.facility_number);
        this.form.facilities[index].facility_name = data.name;
        document.getElementById('facility '+index).value = data.name;
        this.form.facilities[index].allSites = data.sites;
      },
      addFacility() {
        //  add facility when user click '+'
        this.form.facilities.push(
          {
            "facility_number":'',
            "facility_name":'',
            "sites":[],
            "allSites":[],
          }
        );
      },
      checkDiff(o1,o2){
        /**
         * check 2 obj diff,only submit difference
         * it will return keys/values from o2 that are not identical to their counterparts in o1
         */
        let diff = Object.keys(o2).reduce((diff, key) => {
          if (o1[key] === o2[key]) return diff
          return {
            ...diff,
            [key]: o2[key]
          }
        }, {})
        return diff;
      },

      save(){
        this.disableSave = false;
        if(this.valueExistInObjArray(constants.NATA_ROLE_AR,this.form.roles) && this.valueExistInObjArray(constants.NATA_ROLE_CM,this.form.roles))
        {
          this.validateFacility();
          this.validateCommittee();
          if(this.personalDetailIsReady && this.facilityDetailIsReady && this.committeeIsReady){
            this.isConfirm = true;
          }else{
            this.isConfirm = false;
          }
        }
        else if(this.valueExistInObjArray(constants.NATA_ROLE_AR,this.form.roles)){
          this.validateFacility();
          if(this.personalDetailIsReady && this.facilityDetailIsReady){
            this.isConfirm = true;
          }else{
            this.isConfirm = false;
          }
        }
        else if(this.valueExistInObjArray(constants.NATA_ROLE_CM,this.form.roles)){
          this.validateCommittee();
          if(this.personalDetailIsReady && this.committeeIsReady){
            this.isConfirm = true;
          }else{
            this.isConfirm = false;
          }
        }else {
          if(this.personalDetailIsReady){
            this.isConfirm = true;
          }else{
            this.isConfirm = false;
          }
        }
        if(this.isConfirm){
          let diff = this.checkDiff(this.original,this.form);
          if(!this.updatedSubscription) {
            this.updatedSubscription = this.formatSubscriptionListForCheckBox(this.form.subscriptions);
          }
          this.form.subscriptions = this.updatedSubscription;
          // remove all sites before submit.
          this.removeAllSitesForSelectedFacilities();
          if(!this.validate_TA_UserInfoUpdates()) {
            // Error in TA Profile data. disable save.
            this.disableSave = true;
            const backupForm = {...this.form};
            setTimeout(()=> {
              this.form = {...backupForm}
              this.disableSave = false;
            },700);
            return false;
          }
          this.$store.dispatch(UPDATE_USER_DETAIL,[this.$route.params.id,this.form])
            .then(response => {
              this.$notify({
                title: 'Success',
                text: response.data,
                type: 'success'
              });
              if(response.success){
                this.$router.push(routes.ADMIN.USERS);
              }
            })
            .catch(error => {
              this.$notify({
                title: 'Error',
                text: error.response.data.data,
                type: 'error'
              });
            })
        }
      },
      validate_TA_UserInfoUpdates() {
        if(!this.valueExistInObjArray(constants.NATA_ROLE_TA,this.form.roles)){
          this.isConfirm = true;
          return true;
        }
        if(this.currentUser.user_info && this.isTAAdmin()) {
            this.form.user_info = {};
            this.form.user_info.csv_info = this.currentUser.user_info.csv_info;
            // validate at least one email to be marked as primary.
            let primaryObj = this.validate_PrimarySelection(this.form.user_info.csv_info.emails, 'email');
            if(primaryObj) {
              this.form.email = primaryObj.email;
            }else {
              return false;
            }
            primaryObj = this.validate_PrimarySelection(this.form.user_info.csv_info.phones, 'phone');
            if(primaryObj) {
              this.form.mobile_number = primaryObj.countryCode+''+primaryObj.phoneNumber;
            }else {
              return false;
            }
            primaryObj = this.validate_PrimarySelection(this.form.user_info.csv_info.addresses, 'address')
            if(primaryObj) {
              this.form.address = primaryObj.AddressLine;
              this.form.country = primaryObj.Country;
              this.form.postcode = primaryObj.Postcode;
              this.form.state = primaryObj.State;
              this.form.suburb = primaryObj.Suburb;
            }else {
              return false;
            }
        }
        return true;
      },
      validate_PrimarySelection(arr, type) {
        const primaryObj = arr.filter(e => e.isPrimary)
        if(primaryObj.length == 0) {
          // Email Error
          this.$notify({
            title: 'Error',
            text: `At least one ${type} should be marked as primary ${type}.`,
            type: 'error'
          });
          return false;
        }
        return primaryObj[0];
      },
      validateFacility(){
        this.facilityDetailIsReady = false;
        if(!this.facilityDetailIsReady){
          for(var i =0; i < this.form.facilities.length; i++)
          {
            if(this.form.facilities[i].facility_name.length > 0){
              document.getElementById('facility_number '+i).readOnly = true;
            }
            if(this.form.facilities[i].facility_name.length === 0){
              this.facilityError = 'Facility Name for Facility ' + parseInt(i+1) + ' is missing!';
              this.$notify({
                title: 'Error',
                text: this.facilityError,
                type: 'error'
              });
              break;
            }else if(this.form.facilities[i].allSites && this.form.facilities[i].allSites.length > 0 && this.form.facilities[i].sites.length === 0){
              this.facilityError = 'At least 1 site should be choose for Facility '+this.form.facilities[i].facility_number+' - '+this.form.facilities[i].facility_name;
              this.$notify({
                title: 'Error',
                text: this.facilityError,
                type: 'error'
              });
              break;
            }else {
              this.facilityError = '';
            }
          }
          this.facilityDetailIsReady = this.facilityError.length === 0;
        }
      },
      validateCommittee(){
        // Fixing NATA-1253
        this.form.committees = this.form.committees.filter(ele => {
          return ele.id && ele.value.length > 0;
        });
        if(this.form.committees.length > 0){
          this.committeeIsReady = true;
        }else{
          this.committeeIsReady = false;
          this.$notify({
            title: 'Error',
            text: 'At least 1 committee should be selected!',
            type: 'error'
          });
        }
      },
      cancel(){
        this.$router.push(routes.ADMIN.USER + this.$route.params.id)
      },
      formatSubscriptionListForCheckBox(list) {
        let res = [];
        let resEle = null;
        list.forEach(ele => {
          let resEleArr = res.filter(ele1 => ele1.id === ele.parent_id);
          if(resEleArr.length > 0) {
            resEle = resEleArr[0];
            }else {
            resEle = {
              'id':ele.parent_id, 'value':'root category',
              'items': []
            }
            res.push(resEle);
          }
          resEle.items.push(
              {'id':ele.id, 'value':ele.name}
            );
        });
        return res;
      },
      getElementById(arr, id) {
        return arr.filter(ele => ele.id === id)[0];
      },
      formatCheckboxList(categories){
        let result = [];
        for(let category of categories){
          let cat = {};
          cat.id = category.id;
          cat.value = category.name;
          cat.items = [];
          if(category.children){
            for(let child of category.children){
              let subCat = {};
              subCat.id = child.id;
              subCat.value = child.name;
              subCat.selected = true;
              cat.items.push(subCat);
            }
          }
          result.push(cat)
        }
        return result;
      },
      setAllSitesForSelectedFacilities: async function(selFacilities) {
          for(let ele of selFacilities) {
            ele.allSites = [];
            await this.$store.dispatch(GET_FACILITY_INFO, ele.facility_number).then(res => {
              ele.allSites = res.sites;
            });
          }
      },
      removeAllSitesForSelectedFacilities: async function() {
        if(this.form.facilities)
          for(let ele of this.form.facilities) {
            delete ele.allSites;
          }
      },
      isTAAdmin() {
        const current_role = localStorage.getItem(constants.CURRENT_ROLE);
        return current_role === constants.NATA_ROLE_TA_ADMIN;
      },
      isTAUserAndHasUserInfo() {
        return this.isTAUser() && this.currentUser.user_info;
      },
      isTAUser() {
        if(this.currentUser.roles)
          return this.currentUser.roles.filter(ele => ele.id == constants.NATA_ROLE_TA_ID).length > 0;
        return false;
      },
      getAddressTitle(item) {
        return item.Type + ' Address';
      },
      countryChange(evt, addressItem) {
        this.addressTypeStatesDisabled[`${addressItem.Type}_State`] = !this.isCountryIsAustralia(addressItem.Country);
      },
      isCountryIsAustralia(country) {
        return country.toString().toLowerCase() === 'australia' || country.toString().toLowerCase() === 'au'
      },
      primaryOptionChange(obj, e, type, index) {
        this.currentUser.user_info.csv_info[obj].forEach(ele => {
          if(ele.Type == type) {
            ele.isPrimary = true;
          }else
            ele.isPrimary = false;
          const fromState = this.getValueFromUserObject(obj, type);
          if(fromState.isPrimary !== ele.isPrimary) {
            //console.log('Primary Type changed for '+obj+', to '+type);
          }
        });
      },
      getValueFromUserObject(obj, type) {
        if(!this.$store.getters.getUser.user_info) {
          this.$store.getters.getUser.user_info = this.currentUser.user_info;
        }
        return this.$store.getters.getUser.user_info.csv_info[obj].find(ele => {
          return ele.Type == type;
        });
      },
    }
  }
</script>
